<template>
	<AlertCardWrapper @action-button-click="actionButtonClick" :actionTitle="actionTitle" :titleArr="titleArr" :alert="alert" />
</template>

<script>
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
export default {
	name: 'AllowExtensionInjection',
	mixins: [AlertTypeBaseMixin],
	computed: {
		actionTitle() {
			return 'Allow';
		},
		titleArr() {
			return [{ text: 'Allow the extension to add features to your apps' }];
		},
	},
	methods: {
		async actionButtonClick() {
			const permissionGranted = await ExtensionCommunicationService.askForPermissionToAllUrlsIfExtensionInstalled();
			if (permissionGranted) {
				this.markAlertAsCompleted();
			}
		},
	},
};
</script>
<style lang="scss" scoped></style>
